import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Filter, Download, Eye, MessageCircle, MoreHorizontal, Save } from 'lucide-react';
import { Layout } from '../components/layout/Layout';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Badge } from '../components/ui/Badge';
import { Card } from '../components/ui/Card';
import { Modal } from '../components/ui/Modal';
import { Textarea } from '../components/ui/Textarea';
import { useToast } from '../components/ui/Toast';
import { customers } from '../utils/mockData';
import { formatCurrency, formatDate } from '../utils/format';
export function Clientes() {
  const navigate = useNavigate();
  const {
    addToast
  } = useToast();
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [activeTab, setActiveTab] = useState('historico');
  const toggleSelectAll = () => {
    if (selectedRows.length === filteredCustomers.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(filteredCustomers.map(c => c.id));
    }
  };
  const toggleSelectRow = (id: string) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter(rowId => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };
  const handleExportCampaign = () => {
    navigate('/campanhas', {
      state: {
        selectedCustomers: selectedRows.length
      }
    });
  };
  const filteredCustomers = customers.filter(customer => {
    const matchesSearch = customer.storeName.toLowerCase().includes(searchTerm.toLowerCase()) || customer.contactName.toLowerCase().includes(searchTerm.toLowerCase()) || customer.city.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter ? customer.status.toLowerCase() === statusFilter.toLowerCase() : true;
    return matchesSearch && matchesStatus;
  });
  return <Layout data-id="element-251">
      <div className="space-y-6" data-id="element-252">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-253">
          <div data-id="element-254">
            <h1 className="text-3xl font-bold text-white" data-id="element-255">
              Carteira de Clientes
            </h1>
            <p className="text-text-muted" data-id="element-256">
              Gerencie seus contatos e histórico de compras.
            </p>
          </div>
          <div className="flex gap-3 w-full md:w-auto" data-id="element-257">
            {selectedRows.length > 0 && <Button variant="secondary" className="animate-in fade-in zoom-in" onClick={handleExportCampaign} data-id="element-258">
                Exportar para Campanha ({selectedRows.length})
              </Button>}
            <Button variant="primary" icon={<Download className="h-4 w-4" data-id="element-260" />} data-id="element-259">
              Exportar CSV
            </Button>
          </div>
        </div>

        {/* Filters */}
        <Card className="p-4" data-id="element-261">
          <div className="flex flex-col md:flex-row gap-4" data-id="element-262">
            <div className="flex-1" data-id="element-263">
              <Input placeholder="Buscar por nome, loja ou cidade..." icon={<Search className="h-4 w-4" data-id="element-265" />} value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-264" />
            </div>
            <div className="flex gap-4" data-id="element-266">
              <select className="bg-slate-800 border border-slate-700 rounded-lg px-4 py-2 text-sm text-text-primary focus:outline-none focus:border-primary" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-267">
                <option value="" data-id="element-268">Status: Todos</option>
                <option value="ativo" data-id="element-269">Ativo</option>
                <option value="morno" data-id="element-270">Morno</option>
                <option value="frio" data-id="element-271">Frio</option>
              </select>
              <select className="bg-slate-800 border border-slate-700 rounded-lg px-4 py-2 text-sm text-text-primary focus:outline-none focus:border-primary" data-id="element-272">
                <option value="" data-id="element-273">Última Compra</option>
                <option value="7" data-id="element-274">7 dias</option>
                <option value="30" data-id="element-275">30 dias</option>
                <option value="90" data-id="element-276">90+ dias</option>
              </select>
            </div>
          </div>
        </Card>

        {/* Table */}
        <Card className="overflow-hidden" data-id="element-277">
          <div className="overflow-x-auto" data-id="element-278">
            <table className="w-full text-sm text-left" data-id="element-279">
              <thead className="text-xs text-text-muted uppercase bg-slate-900/50 border-b border-slate-700" data-id="element-280">
                <tr data-id="element-281">
                  <th className="p-4 w-4" data-id="element-282">
                    <input type="checkbox" className="rounded border-slate-700 bg-slate-800 text-primary focus:ring-primary" checked={selectedRows.length === filteredCustomers.length && filteredCustomers.length > 0} onChange={toggleSelectAll} data-id="element-283" />
                  </th>
                  <th className="px-6 py-3" data-id="element-284">Loja / Contato</th>
                  <th className="px-6 py-3" data-id="element-285">Status</th>
                  <th className="px-6 py-3" data-id="element-286">Última Compra</th>
                  <th className="px-6 py-3" data-id="element-287">Frequência</th>
                  <th className="px-6 py-3" data-id="element-288">Total Gasto</th>
                  <th className="px-6 py-3 text-right" data-id="element-289">Ações</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-700/50" data-id="element-290">
                {filteredCustomers.map(customer => <tr key={customer.id} className="hover:bg-slate-800/50 transition-colors group" data-id="element-291">
                    <td className="p-4" data-id="element-292">
                      <input type="checkbox" className="rounded border-slate-700 bg-slate-800 text-primary focus:ring-primary" checked={selectedRows.includes(customer.id)} onChange={() => toggleSelectRow(customer.id)} data-id="element-293" />
                    </td>
                    <td className="px-6 py-4" data-id="element-294">
                      <div className="font-medium text-white" data-id="element-295">
                        {customer.storeName}
                      </div>
                      <div className="text-xs text-text-muted" data-id="element-296">
                        {customer.contactName} • {customer.city}
                      </div>
                    </td>
                    <td className="px-6 py-4" data-id="element-297">
                      <Badge variant={customer.status === 'Ativo' ? 'success' : customer.status === 'Morno' ? 'warning' : 'neutral'} dot data-id="element-298">
                        {customer.status}
                      </Badge>
                    </td>
                    <td className="px-6 py-4 text-text-secondary" data-id="element-299">
                      {formatDate(customer.lastPurchase)}
                    </td>
                    <td className="px-6 py-4" data-id="element-300">
                      <Badge variant="info" data-id="element-301">{customer.purchaseFrequency}</Badge>
                    </td>
                    <td className="px-6 py-4 font-medium text-white" data-id="element-302">
                      {formatCurrency(customer.totalSpent)}
                    </td>
                    <td className="px-6 py-4 text-right" data-id="element-303">
                      <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-304">
                        <button onClick={() => setSelectedCustomer(customer)} className="p-1.5 hover:bg-slate-700 rounded text-text-muted hover:text-white" title="Ver Detalhes" data-id="element-305">
                          <Eye className="h-4 w-4" data-id="element-306" />
                        </button>
                        <button onClick={() => navigate('/whatsapp')} className="p-1.5 hover:bg-emerald-500/10 rounded text-emerald-500 hover:text-emerald-400" title="WhatsApp" data-id="element-307">
                          <MessageCircle className="h-4 w-4" data-id="element-308" />
                        </button>
                        <button className="p-1.5 hover:bg-slate-700 rounded text-text-muted hover:text-white" data-id="element-309">
                          <MoreHorizontal className="h-4 w-4" data-id="element-310" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="p-4 border-t border-slate-700 flex items-center justify-between text-xs text-text-muted" data-id="element-311">
            <span data-id="element-312">Mostrando {filteredCustomers.length} clientes</span>
            <div className="flex gap-2" data-id="element-313">
              <button className="px-3 py-1 rounded border border-slate-700 hover:bg-slate-800 disabled:opacity-50" data-id="element-314">
                Anterior
              </button>
              <button className="px-3 py-1 rounded border border-slate-700 hover:bg-slate-800" data-id="element-315">
                Próximo
              </button>
            </div>
          </div>
        </Card>
      </div>

      {/* Customer Detail Modal */}
      <Modal isOpen={!!selectedCustomer} onClose={() => setSelectedCustomer(null)} title="Detalhes do Cliente" size="lg" data-id="element-316">
        {selectedCustomer && <div className="space-y-6" data-id="element-317">
            <div className="flex items-start justify-between" data-id="element-318">
              <div data-id="element-319">
                <h2 className="text-2xl font-bold text-white" data-id="element-320">
                  {selectedCustomer.storeName}
                </h2>
                <p className="text-text-muted" data-id="element-321">
                  {selectedCustomer.contactName} • {selectedCustomer.phone}
                </p>
                <p className="text-sm text-text-muted mt-1" data-id="element-322">
                  {selectedCustomer.email}
                </p>
              </div>
              <Badge variant={selectedCustomer.status === 'Ativo' ? 'success' : selectedCustomer.status === 'Morno' ? 'warning' : 'neutral'} size="md" dot data-id="element-323">
                {selectedCustomer.status}
              </Badge>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-700" data-id="element-324">
              <div className="flex gap-6" data-id="element-325">
                {['historico', 'timeline', 'tags', 'notas'].map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`
                      pb-3 text-sm font-medium capitalize transition-colors relative
                      ${activeTab === tab ? 'text-primary' : 'text-text-muted hover:text-white'}
                    `} data-id="element-326">
                    {tab}
                    {activeTab === tab && <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-t-full" data-id="element-327" />}
                  </button>)}
              </div>
            </div>

            {/* Tab Content */}
            <div className="min-h-[200px]" data-id="element-328">
              {activeTab === 'historico' && <table className="w-full text-sm text-left" data-id="element-329">
                  <thead className="text-xs text-text-muted uppercase bg-slate-800/50" data-id="element-330">
                    <tr data-id="element-331">
                      <th className="px-4 py-2" data-id="element-332">Data</th>
                      <th className="px-4 py-2" data-id="element-333">Produtos</th>
                      <th className="px-4 py-2 text-right" data-id="element-334">Valor</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-700/50" data-id="element-335">
                    <tr data-id="element-336">
                      <td className="px-4 py-3" data-id="element-337">
                        {formatDate(selectedCustomer.lastPurchase)}
                      </td>
                      <td className="px-4 py-3" data-id="element-338">
                        Kit Batom Matte + Base Líquida
                      </td>
                      <td className="px-4 py-3 text-right font-medium text-white" data-id="element-339">
                        R$ 1.250,00
                      </td>
                    </tr>
                    <tr data-id="element-340">
                      <td className="px-4 py-3" data-id="element-341">10/09/2023</td>
                      <td className="px-4 py-3" data-id="element-342">Paleta Sombras Pro</td>
                      <td className="px-4 py-3 text-right font-medium text-white" data-id="element-343">
                        R$ 890,00
                      </td>
                    </tr>
                  </tbody>
                </table>}

              {activeTab === 'timeline' && <div className="space-y-4 pl-4 border-l-2 border-slate-700" data-id="element-344">
                  <div className="relative" data-id="element-345">
                    <div className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-emerald-500 ring-4 ring-slate-900" data-id="element-346" />
                    <p className="text-sm text-white" data-id="element-347">Compra realizada</p>
                    <p className="text-xs text-text-muted" data-id="element-348">Há 2 dias</p>
                  </div>
                  <div className="relative" data-id="element-349">
                    <div className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-blue-500 ring-4 ring-slate-900" data-id="element-350" />
                    <p className="text-sm text-white" data-id="element-351">
                      Campanha enviada (Black Friday)
                    </p>
                    <p className="text-xs text-text-muted" data-id="element-352">Há 5 dias</p>
                  </div>
                  <div className="relative" data-id="element-353">
                    <div className="absolute -left-[21px] top-1 h-3 w-3 rounded-full bg-slate-500 ring-4 ring-slate-900" data-id="element-354" />
                    <p className="text-sm text-white" data-id="element-355">Cliente cadastrado</p>
                    <p className="text-xs text-text-muted" data-id="element-356">Há 2 meses</p>
                  </div>
                </div>}

              {activeTab === 'tags' && <div className="flex flex-wrap gap-2" data-id="element-357">
                  {selectedCustomer.tags.map((tag: string) => <span key={tag} className="px-3 py-1 rounded-full bg-slate-800 text-sm text-white border border-slate-700 flex items-center gap-2" data-id="element-358">
                      {tag}
                      <button className="hover:text-red-400" data-id="element-359">
                        <X className="h-3 w-3" data-id="element-360" />
                      </button>
                    </span>)}
                  <button className="px-3 py-1 rounded-full border border-dashed border-slate-600 text-sm text-text-muted hover:text-white hover:border-slate-500 transition-colors" data-id="element-361">
                    + Adicionar Tag
                  </button>
                </div>}

              {activeTab === 'notas' && <div className="space-y-4" data-id="element-362">
                  <Textarea placeholder="Adicione uma nota interna sobre este cliente..." data-id="element-363" />
                  <div className="flex justify-end" data-id="element-364">
                    <Button size="sm" variant="primary" icon={<Save className="h-4 w-4" data-id="element-366" />} onClick={() => addToast('Nota salva com sucesso!', 'success')} data-id="element-365">
                      Salvar Nota
                    </Button>
                  </div>
                </div>}
            </div>
          </div>}
      </Modal>
    </Layout>;
}
// Helper icon for tags
function X({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-367">
      <line x1="18" y1="6" x2="6" y2="18" data-id="element-368"></line>
      <line x1="6" y1="6" x2="18" y2="18" data-id="element-369"></line>
    </svg>;
}